module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_rushing_yds/blue-aac47d1b5f8c10bf4223a68823d72c68.svg";